import { FormRequest } from './common';

export default class RecoveryFormRequest extends FormRequest {
    protected rules = {
        phone_number: [
            {
                phone: true,
                message: 'Le numéro de téléphone est invalide',
            },
        ],
    };
}
